<template>
  <div>
    <template v-if="error.statusCode === 404">
      <h1 slot="title" class="sf-sb sf-c-ternary">{{ $t('layout.error-404-headline') }}</h1>
      <p v-for="(text, index) of error404Text" :key="`error-404-text${index}`">
        {{ text }}
      </p>
      <nuxt-link v-for="(link, index) in links" :key="`error-404.link${index}`" :to="localePath(link)" class="link">
        {{ $t(`layout.error-404-links.${index}`) }}
      </nuxt-link>
      <debug/>
    </template>

    <template v-else>
      <div class="sf-cg sf-pv">
        <h1 slot="title" class="sf-sb sf-c-ternary">{{ $t('error-500.headline') }}</h1>
        <p>{{ $t(`error-500.text`) }}</p>
        <debug/>
      </div>
    </template>
  </div>
</template>

<script>
import ErrorPage from '~core/pages/error';
import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default {
  extends: ErrorPage,
  layout: 'blank',
  data() {
    return {
      links: [WEB_ROUTES.MAIN, WEB_ROUTES.FAQ, WEB_ROUTES.CONTACT],
    };
  },
  computed: {
    error500Text() {
      return this.$t('layout.error-500-text');
    },
    error404Text() {
      return this.$t('layout.error-404-text');
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  display: block;
  margin-bottom: map-get($margins, xsmall);
}
</style>

<i18n>
{
  "ru": {
    "error-500": {
      "headline": "Сайт закрыт на профилактические работы.",
      "text": "На Manato.az ведутся плановые технические работы по улучшению сайта."
    }
  },
  "az": {
    "error-500": {
      "headline": "Sayt keçirilən planlı profilaktik işlərlə əlaqədar hazırda çalışmır.",
      "text": "Manato.az saytın təkmilləşdirilməsi üçün planlı texniki işlər aparılır"
    }
  }
}
</i18n>
